module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-unknown-2.45d6ba04.svg";